import { render } from "./resources.cattle.io.restore.vue?vue&type=template&id=f04c2294"
import script from "./resources.cattle.io.restore.vue?vue&type=script&lang=js"
export * from "./resources.cattle.io.restore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__